import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getStudentClientVersion } from './util_04_ua';
/**
 * 教育展示页
 * @memberof module:client
 * @param {object} object
 * @param {number} object.id
 * @param {string} object.url
 */

function eduShowWebPage() {
  var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    url: ''
  };
  var isStudentClient = getStudentClientVersion();
  var defaults = {
    id: '',
    url: '',
    title: '',
    width: 1100,
    height: 600,
    noParent: 1,
    top: 70,
    centerTitle: 0,
    left: 620,
    centerParent: 1,
    fixPosition: 0,
    hideIfLoseFocus: 0,
    topmost: 0,
    sizeChangeable: 1,
    highTitle: 1,
    showMaxBtn: 1,
    showMinBtn: 1,
    showCloseBtn: 1,
    showIcon: 1,
    backgroundColor: 0xffffffff,
    // 期望 title bar 是白色的，但不起作用
    miniWidth: 1000,
    miniHeight: 600
  };

  var config = _objectSpread(_objectSpread({}, defaults), opt);

  var id = config.id,
      url = config.url;

  if (url) {
    if (!id) {
      config.id = url;
    }

    if (isStudentClient && window.external && window.external.nativeCall) {
      window.external.nativeCall('EduShowWebPage', [JSON.stringify(config)]);
    } else if (isStudentClient && window.external && window.external.EduShowWebPage) {
      /* istanbul ignore next */
      window.external.EduShowWebPage(JSON.stringify(config));
    } else {
      window.open(url);
    }
  }
}
/**
 * 判断是否在PC客户端的测试模式
 * @memberof module:client
 * @return {boolean} true: 表示在PC客户端的测试模式
 */


function isClientInTest() {
  var isStudentClient = getStudentClientVersion();
  return new Promise(function (resolve, reject) {
    if (isStudentClient && (window.external.EduIsClientInTestEvn || window.external.nativeCall)) {
      if (window.external.nativeCall) {
        window.external.nativeCall('EduIsClientInTestEvn', [], function (resp) {
          var res = resp;

          if (typeof res === 'string') {
            try {
              res = JSON.parse(res);
            } catch (err) {
              console.log(err);
            }
          } // console.log('look at', res.retcode, res.result);


          if (res.retcode === 0 && Number(res.result) === 1) {
            return resolve();
          }

          return reject();
        });
      } else {
        if (Number(window.external.EduIsClientInTestEvn()) === 1) {
          return resolve();
        }

        return reject();
      }
    } else {
      return reject();
    }
  });
}

export { eduShowWebPage, isClientInTest };